import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { filterUndefined } from '@core/shared/util';

import { ConfirmDialogData } from '../../confirm-dialog/confirm-dialog-data';
import { ConfirmDialogService } from '../../confirm-dialog/confirm-dialog.service';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesHandlerService {
  private readonly confirmDialogService: ConfirmDialogService = inject(ConfirmDialogService);

  showUnsavedChangesConfirmationDialog(infoMessage: string): Observable<boolean> {
    const dialogData: ConfirmDialogData = {
      title: 'Ungespeicherte Änderungen',
      message: infoMessage,
      trueButtonText: 'Änderungen verwerfen und fortfahren',
      falseButtonText: 'Abbrechen',
    };

    return this.confirmDialogService.open(dialogData).afterClosed().pipe(filterUndefined());
  }
}
